// extracted by mini-css-extract-plugin
export var box = "OfficeCard-module--box--9c351";
export var box_md = "OfficeCard-module--box_md--6662a";
export var box_xmd = "OfficeCard-module--box_xmd--d8618";
export var box_flex = "OfficeCard-module--box_flex--10682";
export var box_lg = "OfficeCard-module--box_lg--0adfa";
export var box_sm = "OfficeCard-module--box_sm--92bd7";
export var box_outer = "OfficeCard-module--box_outer--23aa2";
export var box_whiteBg = "OfficeCard-module--box_white-bg--e7f66";
export var box_noMarginBottom = "OfficeCard-module--box_no-margin-bottom--e5679";
export var box_noPadding = "OfficeCard-module--box_no-padding--1954f";
export var box_outerGray = "OfficeCard-module--box_outer-gray--91858";
export var box_dark = "OfficeCard-module--box_dark--a941e";
export var box_zIndex = "OfficeCard-module--box_z-index--df1ba";
export var box_zIndex6 = "OfficeCard-module--box_z-index-6--d5052";
export var box_eventsWithLine = "OfficeCard-module--box_events-with-line--87b1e";
export var box_featuresAo = "OfficeCard-module--box_features-ao--d2683";
export var box_verticalPaddings = "OfficeCard-module--box_vertical-paddings--7766b";
export var clearP = "OfficeCard-module--clearP--bb0cb";
export var clearP_vc = "OfficeCard-module--clearP_vc--ddc7e";
export var link = "OfficeCard-module--link--83b02";
export var card = "OfficeCard-module--card--97b8d";
export var cardLink = "OfficeCard-module--cardLink--ecd28";
export var row = "OfficeCard-module--row--9fe69";
export var name = "OfficeCard-module--name--905a4";
export var location = "OfficeCard-module--location--46b6f";
export var fadeInAnimation = "OfficeCard-module--fadeInAnimation--0aec8";
export var placeHolderShimmer = "OfficeCard-module--placeHolderShimmer--b3cb8";